<template>
  <div class="bg-gray-50 p-4 shadow">
    <h3 class="text-sm font-medium text-gray-600">{{ title }}</h3>
    <p class="text-lg font-bold text-black">{{ displayValue }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  title: string
  value: string | number | null | undefined
}>()

const { t } = useI18n()

const displayValue = computed(() => {
  if (props.value === undefined || props.value === null) {
    return '-'
  }

  if (props.title === 'Status' && typeof props.value === 'string') {
    const statusKey = `sensors.status.${props.value}`
    const translation = t(statusKey)
    if (translation !== statusKey) {
      return translation
    }
  }

  return props.value
})
</script>
